export const webUserPortalAplicationUrl = process.env.REACT_APP_WEB_USER_PORTAL;

export const notificationRoute = (): string => "/obavijesti";
export const notificationAdministrationRoute = (): string => "/obavijesti-administracija";
export const notificationNewRoute = (): string => "/obavijest/nova";
export const notificationEditRoute = (): string => "/obavijest/:notificationId/uredi";
export const notificationEditUrl = (notificationId: number): string => `/obavijest/${notificationId}/uredi`;
export const notificationDetailRoute =(): string => "/obavijest/:notificationId";
export const notificationDetailUrl = (notificationId: number): string => `/obavijest/${notificationId}`;
export const dashboardRoute = (): string => "/radna-ploha";
export const startRoute = (): string => "/pocetna-stranica";
export const institutionRoute = (): string => "/ustanova";
export const institutionDetailsRoute = (): string => "/ustanova/ustanova-detalj";
export const institutionEditRoute = (): string => "/ustanova/ustanova-uredi";
export const codebookRouteProgramType = (): string => "/sifrarnik-vrsta-programa";
export const codebookRouteProgramName = (): string => "/sifrarnik-naziv-programa";
export const codebookRouteLanguage = (): string => "/sifrarnik-jezik";
export const codebookRouteLanguageLevel = (): string => "/sifrarnik-jezik-razina";
export const codebookRouteEducationSector = (): string => "/sifrarnik-sektor";
export const codebookRouteEducationSubSector = (): string => "/sifrarnik-podsektor";
export const codebookRouteProfession = (): string => "/sifrarnik-zanimanje";
export const codebookRouteFormOfTeaching = (): string => "/sifrarnik-oblik-nastave";
export const codebookRouteEnrollmentCondition = (): string => "/sifrarnik-uvjeti-upisa";
export const codebookRouteEnrollmentConditionDetails = (): string => "/sifrarnik-uvjeti-upisa/:enrollmentConditionId";
export const codebookRouteEnrollmentConditionDetailsUrl = (enrollmentConditionId: number): string => `/sifrarnik-uvjeti-upisa/${enrollmentConditionId}`;
export const codebookRouteKnowledgeCheck = (): string => "/sifrarnik-zavrsetak-programa";
export const userRoleRoute = (): string => "/korisnik-role";
export const createUserRoute = (): string => "/novi-korisnik";

export const programRequestNewRoute = (): string => "/zahtjev/novi";
export const programRequestEditRoute = (): string => "/zahtjevi/:programRequestId/uredi";
export const programRequestEditUrl = (programRequestId: number): string => `/zahtjevi/${programRequestId}/uredi`;
export const programRequestListRoute = (): string => "/zahtjevi-lista";
export const institutionListRoute = (): string => "/ustanove-lista";
export const programRequestDetailsRoute = (): string => "/zahtjevi/:programRequestId";
export const programRequestDetailsUrl = (programRequestId: number): string => `/zahtjevi/${programRequestId}`;
export const programRequestMzoRoute = (): string => "/zahtjev-mzo/:programRequestId";
export const programRequestMzoUrl = (programRequestId: number): string => `/zahtjev-mzo/${programRequestId}`;
export const authRoute = `/auth`;
export const newProgramRequestListRoute = (): string => "/lista-zahtjeva";

export const createGroupProgramRequest = (): string => "/novi-grupni-zahtjev";

export const aboutProgramRoute = (): string => "/o-programu";
export const statementOfAcessibilityRoute = "/izjava-o-pristupacnosti";
export const helpAndSupportRoute = "/help-and-support";
export const faqGroupsAndItemsRoute = "/faq";